export function squish(s: string) {
  return s.trim().replace(/\s+/g, " ");
}
